import apiClient from "../client/apiClient";
import { ENDPOINTS } from "../config/endpoints";
import { normalizeApiError } from "../utils/handleError";
import { unwrapApiResponse } from "../utils/unWrapApiResponse.js";

export const registerFcmToken = async (payload) => {
  try {
    const response = await apiClient.post(ENDPOINTS.REGISTER_FCM, payload);
    return unwrapApiResponse(response, {
      extract: "responseData",
      fallbackMessage: "Failed to register FCM token",
    });
  } catch (error) {
    throw normalizeApiError(error);
  }
};
